import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { getFeedingData } from '@/service/Feeding/FeedingData';
export default function useFeedingData(params) {
  var loading = ref(false);
  var finished = ref(false);
  var refreshing = ref(false);
  var feedingData = ref([]);
  var totalRow = ref(0);
  var totalWeight = ref('0');
  var freight = ref('0');
  // 获取进料记录
  var getFeedingDataAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _feedingData$value, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            loading.value = true;
            _context.next = 4;
            return getFeedingData(params.value);
          case 4:
            data = _context.sent;
            if (refreshing.value) {
              feedingData.value = [];
              refreshing.value = false;
            }
            totalRow.value = data.totalRow;
            totalWeight.value = data.totalWeight;
            freight.value = data.freight;
            (_feedingData$value = feedingData.value).push.apply(_feedingData$value, _toConsumableArray(data.list));
            // 加载状态结束
            loading.value = false;
            // 数据全部加载完成
            if (data.totalRow === feedingData.value.length) {
              finished.value = true;
            }
            _context.next = 18;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](0);
            if (params.value.pageSize != 1) {
              params.value.pageSize -= 1;
            }
            refreshing.value = false;
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 14]]);
    }));
    return function getFeedingDataAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var onLoad = function onLoad() {
    params.value.pageSize += 1;
    getFeedingDataAsync();
  };
  var onRefresh = function onRefresh() {
    // 清空列表数据
    finished.value = false;
    params.value.pageSize = 1;
    getFeedingDataAsync();
  };
  return [feedingData, totalRow, totalWeight, freight, loading, finished, refreshing, onRefresh, getFeedingDataAsync, onLoad];
}